import { Button } from 'react-bootstrap'
import { CirclePlus } from 'lucide-react'

export default function PlusButton(props) {

    const { onClick } = props

    return (
        <>
            <Button
                type='button'
                variant='outline-primary'
                size='sm'
                onClick={onClick}
            >
                <CirclePlus size={14} style={{ marginBottom: '2px' }} />
            </Button>
        </>
    )
}